let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4NPrH")).then(() => parcelRequire('esonG'));